<template>
  <div class="row q-gutter-xs items-center">
    <slot />
    <lwf-toggle
      v-model="props.config.grid"
      flat
      round
      icon="fa fa-table"
      checked-icon="fa fa-columns"
      class="col-auto"
    />
    <q-btn
      flat
      round
      icon="fa fa-cog"
      class="col-auto"
      @click="props.showEditConfig()"
    />
    <btn-table-export-excel
      flat
      class="col-auto"
    />
    <slot name="after" />
  </div>
</template>

<script>
import LwfToggle from 'components/core/LwfToggle'
import BtnTableExportExcel from 'components/Btn/BtnTableExportExcel'

/**
 * Composant générique à placer dans le slot `top-right` d'un QTable
 */
export default {
  name: 'TableConfigurationProviderTopRight',
  components: { BtnTableExportExcel, LwfToggle },
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showExportTable: false
    }
  }
}
</script>

<style scoped>

</style>
